import script from "./EmojisSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmojisSelection.vue?vue&type=script&setup=true&lang=ts"

import "./EmojisSelection.vue?vue&type=style&index=0&id=30efe786&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30efe786"]])

export default __exports__